import { Controller } from "@hotwired/stimulus"

// Presenter clip picker (character-first redesign, Matt 2026-07-02): the
// creator picks a CHARACTER card, then browses/searches THAT character's
// clips inside a Turbo frame served by the paged presenter_clips endpoint —
// teachers carry 1000+ clips, so whole libraries never render into the page.
//
// This controller adds the JS conveniences on top of an already-working
// JS-free flow (character cards are plain links targeting the frame; clip
// radios override the hidden saved value on submit):
//   * live search — debounced, reloads the frame with ?q= for the ACTIVE
//     character only
//   * active-card styling when a character is picked
//
//   <fieldset data-controller="presenter-picker">
//     <a data-presenter-picker-target="card" data-clips-url="…"
//        data-turbo-frame="presenter-clips-…"
//        data-action="presenter-picker#selectCharacter">…</a>
//     <input data-presenter-picker-target="search"
//            data-action="input->presenter-picker#search">
//     <turbo-frame id="presenter-clips-…">…</turbo-frame>
//   </fieldset>
const DEBOUNCE_MS = 350

export default class extends Controller {
  static targets = ["card", "search"]

  connect() {
    this.debounceTimer = null
    // A saved clip preloads its character's frame — adopt that card as active.
    this.activeUrl = this.cardTargets.find(
      (card) => card.classList.contains("presenter-char--active"),
    )?.dataset.clipsUrl || null
  }

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  selectCharacter(event) {
    const card = event.currentTarget
    this.activeUrl = card.dataset.clipsUrl || null
    this.cardTargets.forEach((c) => c.classList.toggle("presenter-char--active", c === card))
    if (this.hasSearchTarget) this.searchTarget.value = ""
    // Frame navigation itself is the link's data-turbo-frame — no JS needed.
  }

  search() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.loadSearch(), DEBOUNCE_MS)
  }

  loadSearch() {
    if (!this.activeUrl) return
    const frame = this.element.querySelector("turbo-frame")
    if (!frame) return

    const url = new URL(this.activeUrl, window.location.origin)
    const query = (this.hasSearchTarget ? this.searchTarget.value : "").trim()
    if (query === "") {
      url.searchParams.delete("q")
    } else {
      url.searchParams.set("q", query)
    }
    frame.src = url.toString()
  }
}
